import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { ChartTooltipProvider, StateBlock, ToastProvider } from '@w7/ui'
import { AppShell } from './AppShell'
import { AuthGate } from './AuthGate'
import { DateRangeProvider } from './range'
import { ThemeProvider } from './theme'
import { ToastFlash } from '@/ui/ToastFlash'

import { LoginPage } from '@/features/auth/LoginPage'
import { CallbackPage } from '@/features/auth/CallbackPage'
import { NoAccessPage } from '@/features/auth/NoAccessPage'
import {
  BothRatesPage,
  BmTurnoverPage,
  ChangePasswordPage,
  CompetitionPage,
  CompListPage,
  CreateCompPage,
  CreateEventPage,
  CreateGamePage,
  CreateHorsePage,
  CreateJodiMarketPage,
  CreateMarketPage,
  CreateUserPage,
  EventListPage,
  FrontTablePage,
  GameListPage,
  GoogleAuthPage,
  HorseListPage,
  InPlayPage,
  JodiMarketsViewPage,
  MaintenancePage,
  MarketListPage,
  MarketsViewPage,
  // MarketSelectPage, // temporarily disabled
  RatesDiffPage,
  RatesPage,
  UserListPage,
} from '@/features/bookmaker'
import { VersionSettingsPage } from '@/features/version/VersionSettingsPage'

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
})

export function App() {
  return (
    <QueryClientProvider client={client}>
      <ThemeProvider>
        <DateRangeProvider>
          <ToastProvider>
            <ChartTooltipProvider>
              <BrowserRouter>
                <ToastFlash />
                <Routes>
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/callback" element={<CallbackPage />} />
                  <Route path="/no-access" element={<NoAccessPage />} />
                  <Route path="/maintenance" element={<MaintenancePage />} />
                  <Route
                    path="*"
                    element={
                      <AuthGate>
                                                  <AppShell>
                            <Routes>
                            <Route path="/" element={<Navigate to="/InPlay" replace />} />
                            {/* Market Selection temporarily disabled — redirect to In Play */}
                            <Route path="/marketSelect" element={<Navigate to="/InPlay" replace />} />
                            <Route path="/hometable" element={<Navigate to="/InPlay" replace />} />
                            {/* <Route path="/marketSelect" element={<MarketSelectPage />} /> */}
                            {/* <Route path="/hometable" element={<MarketSelectPage />} /> */}
                            <Route path="/InPlay" element={<InPlayPage />} />
                            <Route path="/fronttable" element={<FrontTablePage />} />
                            <Route path="/competition" element={<CompetitionPage />} />

                            <Route path="/game" element={<GameListPage />} />
                            <Route path="/creategame" element={<CreateGamePage />} />
                            <Route path="/editgame/:id" element={<CreateGamePage />} />

                            <Route path="/complist" element={<CompListPage />} />
                            <Route path="/createcomp" element={<CreateCompPage />} />
                            <Route path="/editcomp/:id" element={<CreateCompPage />} />

                            <Route path="/eventlist" element={<EventListPage />} />
                            <Route path="/createevent" element={<CreateEventPage />} />
                            <Route path="/editevent/:id" element={<CreateEventPage />} />

                            <Route path="/marketlist" element={<MarketListPage />} />
                            <Route path="/createmarket" element={<CreateMarketPage />} />
                            <Route path="/editmarket/:id" element={<CreateMarketPage />} />
                            <Route path="/createjodimarket" element={<CreateJodiMarketPage />} />
                            <Route path="/marketsview/:id" element={<MarketsViewPage />} />
                            <Route path="/jodimarketsview/:id" element={<JodiMarketsViewPage />} />

                            <Route path="/horselist" element={<HorseListPage />} />
                            <Route path="/createhorse" element={<CreateHorsePage />} />
                            <Route path="/edithorse/:id" element={<CreateHorsePage />} />

                            <Route path="/rates" element={<RatesPage />} />
                            <Route path="/ratesdiff" element={<RatesDiffPage />} />
                            <Route path="/bothRates" element={<BothRatesPage />} />
                            <Route path="/turnover" element={<BmTurnoverPage />} />

                            <Route path="/user" element={<UserListPage />} />
                            <Route path="/createuser" element={<CreateUserPage />} />
                            <Route path="/edituser/:id" element={<CreateUserPage />} />

                            <Route path="/googleAuth" element={<GoogleAuthPage />} />
                            <Route path="/changePassword" element={<ChangePasswordPage />} />
                            <Route path="/settings/version" element={<VersionSettingsPage />} />

                            <Route
                              path="*"
                              element={
                                <StateBlock icon="search" title="That page does not exist">
                                  Unknown Bookmaker-UI route.
                                </StateBlock>
                              }
                            />
                          </Routes>
                          </AppShell>
                                              </AuthGate>
                    }
                  />
                </Routes>
              </BrowserRouter>
            </ChartTooltipProvider>
          </ToastProvider>
        </DateRangeProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
